import { render, staticRenderFns } from "./ContainerOpcoes.vue?vue&type=template&id=5e8b62c6&scoped=true&"
import script from "./ContainerOpcoes.vue?vue&type=script&lang=js&"
export * from "./ContainerOpcoes.vue?vue&type=script&lang=js&"
import style0 from "./ContainerOpcoes.vue?vue&type=style&index=0&id=5e8b62c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b62c6",
  null
  
)

export default component.exports